<template>
<v-container fluid class="error">
  
                <v-row class="justify-center">
                <v-card class="primary pa-5 mx-3">
                  <v-card-title class="justify-center"><h2 class="font-weight-black textTitle--text">{{title}}</h2></v-card-title>
                  <v-card-text class="quinty--text font-weight-black text-h5 text-center">{{message}}</v-card-text>
                  <v-card-actions class="justify-center"><v-btn @click="$emit('close')" class="ma-3 pa-3 font-weight-black black--text success" elevation="12">Ok</v-btn></v-card-actions>
                </v-card>
                </v-row>
              
</v-container>
</template>

<script>
  export default {
      props:['title','message','color'],
    data () {
      return {
        
      }
    },
    mounted(){
       
    },
    methods: {
        
         
    },
  }
</script>